export default "__VITE_ASSET__BTjmYyt5__"